import { Model } from "../mvvm/Model.js";
/** Max copies per job; mirrors the backend cap (#1139). */
export const MAX_SLIP_COPIES = 200;
/** Form input for queuing marketing QR slips on a site's kitchen printer. */
export class SlipPrintDraft extends Model {
    copiesText;
    title;
    qrUrl;
    constructor(copiesText, title, qrUrl) {
        super();
        this.copiesText = copiesText;
        this.title = title;
        this.qrUrl = qrUrl;
    }
    copies() {
        const text = this.copiesText.trim();
        if (!/^\d+$/.test(text))
            return null;
        const n = Number(text);
        return n >= 1 && n <= MAX_SLIP_COPIES ? n : null;
    }
    validate() {
        const errors = [];
        if (this.copies() === null)
            errors.push(`Copies must be 1–${MAX_SLIP_COPIES}.`);
        const url = this.qrUrl.trim();
        if (url && !/^https?:\/\/\S+$/i.test(url))
            errors.push("QR link must start with http:// or https://.");
        return errors;
    }
    toInput() {
        this.assertValid();
        return { copies: this.copies(), title: this.title.trim(), qrUrl: this.qrUrl.trim() };
    }
}
/** One queued/printed slip job with display rules. */
export class SlipPrintJobModel extends Model {
    row;
    constructor(row) {
        super();
        this.row = row;
    }
    get id() {
        return this.row.id;
    }
    validate() {
        return [];
    }
    isOpen() {
        return this.row.status === "queued" || this.row.status === "printing";
    }
    progressLabel() {
        return `${this.row.printed} / ${this.row.copies}`;
    }
    statusLabel() {
        return this.row.status === "failed" && this.row.error
            ? `failed: ${this.row.error}`
            : this.row.status;
    }
}
//# sourceMappingURL=SlipPrint.js.map